import * as React from "react";
const SvgFiRrPadlockCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-padlock-check_svg__a)">
      <path
        fill="#062147"
        d="M17 10a7.01 7.01 0 0 0-6.416 4.21A.98.98 0 0 0 10 14a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1c.027 0 .051-.013.078-.016C10.559 21.378 13.476 24 17 24c3.86 0 7-3.141 7-7s-3.14-7-7-7m0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5m3.221-6.212a1 1 0 0 1-.029 1.414l-2.212 2.124a2.35 2.35 0 0 1-1.653.671 2.38 2.38 0 0 1-1.664-.674l-1.132-1.108a1 1 0 0 1 1.399-1.43l1.132 1.108a.374.374 0 0 0 .522 0l2.223-2.134a1 1 0 0 1 1.414.029M10 23a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5v-6a5 5 0 0 1 3-4.576V7c0-3.86 3.14-7 7-7s7 3.14 7 7a1 1 0 0 1-2 0c0-2.757-2.243-5-5-5S5 4.243 5 7v1h8a1 1 0 0 1 0 2H5c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h4a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-padlock-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPadlockCheck;
